import { styled } from '@vebox/etui-system';
import { useState, createElement, Children, cloneElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../ScrollingMenu/defaultSettings.js';
import '../ScrollingMenu/utils/index.js';
import '../ScrollingMenu/InnerWrapper.js';
import ScrollingMenu from '../ScrollingMenu/ScrollingMenu.js';
import '../ScrollingMenu/ArrowWrapper.js';

const _excluded = ["theme"];
const TabsListDiv = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    height: theme.shape.tabsHeight,
    m: 0,
    p: 0
  }, props);
})``;

const TabsList = ({
  children,
  styles = {}
}) => {
  const [selected, setSelected] = useState(null);
  const handleSelect = key => {
    setSelected(key);
  };
  const renderTabs = () => {
    const items = Children.map(children, (child, index) => {
      return /*#__PURE__*/cloneElement(child, {
        key: index
      });
    });
    return /*#__PURE__*/createElement(ScrollingMenu, {
      data: items,
      arrowLeft: /*#__PURE__*/createElement(ScrollingMenu.ShadowAsArrow, {
        left: true
      }),
      arrowRight: /*#__PURE__*/createElement(ScrollingMenu.ShadowAsArrow, null),
      hideArrows: true,
      hideSingleArrow: true,
      scrollToSelected: true,
      onSelect: handleSelect,
      selected: selected,
      clickWhenDrag: false,
      alignCenter: false,
      inertiaScrolling: false,
      innerWrapperStyle: styles.innerWrapper,
      menuWrapperStyle: styles.menuWrapper,
      menuStyle: styles.menu,
      itemStyle: styles.item,
      wrapperStyle: styles.wrapper
    });
  };
  return /*#__PURE__*/createElement(TabsListDiv, null, renderTabs());
};

export default TabsList;
